import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import ContentWrapper from "../components/ContentWrapper";
import { useEffect } from "react";
import { getPrivacyPolicy } from "../state/actions/profile-actions";
import LoadingDiv from "../components/LoadingDiv";

const PrivacyPolicy = () => {

  const { policy, loaders  } = useSelector(state => ({
    policy: null,
    loaders: state?.profile?.loaders?.policy,
  }),shallowEqual );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPrivacyPolicy());
  }, []);

  return (
    <ContentWrapper title={"Policy"}>
      {loaders ? (
        <LoadingDiv />
      ) : (
        <>
          {policy?.data?.[0]?.posts?.content ? <div
            className="p-4 text-white whitespace-pre-line bg-gray-400 opacity-60 rounded-lg"
            dangerouslySetInnerHTML={{ __html: policy?.data?.[0]?.posts?.content }}
          ></div> : <p className='text-center'>No policy found</p>}
        </>
      )}
    </ContentWrapper>
  );
};

export default PrivacyPolicy;
